// extracted by mini-css-extract-plugin
export default {"collapse":"ProductDescription_collapse__FJcsb"};